/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Finalcta_Nav_ReferralInputs */

const tr_landing_finalcta_nav_referral = /** @type {(inputs: Landing_Finalcta_Nav_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davet Et, Kazan`)
};

const en_landing_finalcta_nav_referral = /** @type {(inputs: Landing_Finalcta_Nav_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refer & Earn`)
};

const de_landing_finalcta_nav_referral = /** @type {(inputs: Landing_Finalcta_Nav_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empfehlen & Profitieren`)
};

const ru_landing_finalcta_nav_referral = /** @type {(inputs: Landing_Finalcta_Nav_ReferralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приглашайте и зарабатывайте`)
};

/**
* | output |
* | --- |
* | "Refer & Earn" |
*
* @param {Landing_Finalcta_Nav_ReferralInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_finalcta_nav_referral = /** @type {((inputs?: Landing_Finalcta_Nav_ReferralInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Finalcta_Nav_ReferralInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_finalcta_nav_referral(inputs)
	if (locale === "de") return de_landing_finalcta_nav_referral(inputs)
	if (locale === "ru") return ru_landing_finalcta_nav_referral(inputs)
	return tr_landing_finalcta_nav_referral(inputs)
});